// extracted by mini-css-extract-plugin
export default {"heading":"article_heading__mEVyS","code":"article_code__D4e+w","copy":"article_copy__6oS5v","grid":"article_grid__8GROJ","row":"article_row__sGGGs"};